import {lax} from '../bootstrap';

window.addEventListener('load', function () {

    lax.init()

    lax.addDriver('scrollY', function () {
        return window.scrollY;
    })

    lax.addElements(
        '.lax-circle',
        {
            scrollY: {
                translateY: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        991: [0, 'screenWidth/2', 'screenWidth'],
                        1024: [0, 'screenWidth/4', 'screenWidth/2'],
                    }
                ],
            }
        }
    )

    lax.addElements(
        '.lax-card-image',
        {
            scrollY: {
                translateY: [
                    ['elInY', 'elCenterY', 'elOutY'],
                    [10, 0, -20],
                    {
                        easing: 'easeInCubic'
                    }
                ]
            }
        }
    )

    let codeFrame = document.querySelector('.api');

    if (codeFrame) {
        let image = document.querySelector('.lax-cursor-image');

        codeFrame.addEventListener('mousemove', function (e) {
            lax.__codeCursorX = e.clientX;
            lax.__codeCursorY = e.clientY;
        }, false)

        lax.addDriver('codeCursorX', function () {
            return lax.__codeCursorX || 0;
        })

        lax.addDriver('codeCursorY', function () {
            return lax.__codeCursorY || 0;
        })

        const laxCursorOptions = {
            'codeCursorX': {
                "translateX": [
                    [0, 'screenWidth'],
                    [50, -50],
                    {
                        inertia: 15
                    }
                ],
            },
            'codeCursorY': {
                "translateY": [
                    [0, 'screenHeight'],
                    [50, -50],
                    {
                        inertia: 15
                    }
                ],
            },
        }

        if (window.innerWidth > 1024) {
            lax.addElements('.lax-cursor-image', laxCursorOptions);
        }

        window.addEventListener('resize', function () {
            if(window.innerWidth > 1024) {
                lax.addElements('.lax-cursor-image', laxCursorOptions);
            } else {
                lax.removeElements('.lax-cursor-image');
                image.removeAttribute('style')
            }
        })

    }
})
